<div
  class="bulk-modal-title display-flex align-items-center no-wrap"
  mat-dialog-title
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane">
  Downloading inspection reports...
</div>

<mat-dialog-content>
  <div class="bulk-mode-modal">
    <ng-container *ngIf="(isGenerating$ | async) === true; else downloadProgress">
      <div class="progress-container">
        <div class="operations">
          <mat-spinner [diameter]="16" color="primary" mode="indeterminate"></mat-spinner>

          <div class="current-operation">Generating PDF reports...</div>
        </div>

        <div class="progress-bar" *ngIf="progress$ | async as progress">
          <mat-progress-bar mode="determinate" [value]="progress * 100" color="primary"></mat-progress-bar>
          <span class="counter">{{ downloadService.completedCount }} / {{ downloadService.totalCount }}</span>
        </div>
      </div>
    </ng-container>

    <ng-template #downloadProgress>
      <div class="progress-container" *ngIf="!isCompleted">
        <div class="operations">
          <mat-spinner [diameter]="16" color="primary" mode="indeterminate"></mat-spinner>

          <div class="current-operation">Downloading reports...</div>
        </div>

        <div class="progress-bar" *ngIf="progress$ | async as progress">
          <mat-progress-bar mode="determinate" [value]="progress * 100" color="primary"></mat-progress-bar>
          <span class="counter">{{ downloadService.completedCount }} / {{ downloadService.totalCount }}</span>
        </div>
      </div>

      <div class="results-list" *ngIf="isCompleted && failedDownloads.length">
        <div class="result-title">Failed to download reports for:</div>
        <div *ngFor="let item of failedDownloads" class="result-item">
          <div class="result-content">
            <mat-icon color="warn">error</mat-icon>
            <span class="item-params">
              {{ item.inspection.unit?.propertyName || 'Property' }}
              {{ item.inspection.unit?.name ? '(' + item.inspection.unit?.name + ')' : '' }}
            </span>
          </div>
          <div class="result-error">
            <ng-container *ngIf="item.fileId">FileId: {{ item.fileId + ' - ' }}</ng-container>
            {{ item.error }}
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="isCompleted && failedDownloads.length" align="end">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
